import React, { Component } from 'react'
import axios from 'axios';

import { addURL } from '../../redux/actions/url'
import { sessionToken, sessionRole, sessionUser } from '../../redux/actions/session'
import { showLoading } from '../../redux/actions/loading'
import { getParam } from '../../redux/actions/gblparam'
import axiosException from "../../plugin/exceptionmessage"
import { Form, Button } from 'react-bootstrap';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            hidden: true,
            validated: false
        };
    }

    componentWillMount() {
        let store = this.props.store;
        store.dispatch(addURL(this.props.location.pathname))
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = (e) => {
        // const form = e.currentTarget;
        // if (form.checkValidity() === false) {
        //     e.preventDefault();
        //     // e.stopPropagation();
        // }
        this.login()
        e.preventDefault();
        this.setState({
            validated: true
        })
    }

    toggleShow() {
        this.setState({ hidden: !this.state.hidden })
    }

    login = async () => {
        let store = this.props.store;
        try {
            store.dispatch(showLoading(true))
            let validationLogin = await axios.get(process.env.REACT_APP_BACKEND + `account/checkPasswordIsReset/${this.state.username}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*'
                }
            })

            if (validationLogin.data === true) {
                store.dispatch(showLoading(false))
                window.location.href = '/createNewPassword'
            } else {
                let loginResponse = await axios.post(process.env.REACT_APP_BACKEND + 'wp/participant/authenticate', this.state, {
                    headers: {
                        'Access-Control-Allow-Origin': '*'
                    }
                })

                store.dispatch(sessionToken(loginResponse.data.id_token))
                await this.getGlobalParam(loginResponse.data.id_token)
                // store.dispatch(sessionToken(this.state.username))

                let userData = await axios.get(process.env.REACT_APP_BACKEND + 'wp/participant/account', {
                    headers: {
                        Authorization: 'Bearer ' + loginResponse.data.id_token //the token is a variable which holds the token
                    }
                })

                let userSession = {
                    username: userData.data.login,
                    participantId: loginResponse.data.props.participant_id
                }

                store.dispatch(sessionRole(userData.data.sysGroups))
                store.dispatch(sessionUser(userSession))
                // store.dispatch(sessionUser(userData.data.login))
                store.dispatch(showLoading(false))
            }
        } catch (error) {
            // confirmAlert({
            //     customUI: ({ onClose }) => {
            //         return (
            //             <div className='alert-custom-ui'>
            //                 <h1>Login Failed</h1>
            //                 <p>{axiosException(error)}</p>
            //                 <button className='btn btn-blue text-white' onClick={onClose}>Tutup</button>
            //             </div>
            //         );
            //     }
            // });
            var elemMessage = document.getElementById("errorMessage");
            elemMessage.innerHTML = axiosException(error);
            document.getElementById("error").style.display = "block";
            // confirmAlert({
            //     title: 'Login Failed',
            //     message: axiosException(error),
            //     buttons: [
            //         {
            //             label: 'Tutup',
            //         },
            //     ]
            // });
            store.dispatch(showLoading(false))
        }

    }

    getGlobalParam = async (token) => {
        let store = this.props.store;

        let gblParamData = await axios.get(process.env.REACT_APP_BACKEND + 'global-parameters', {
            headers: {
                Authorization: 'Bearer ' + token //the token is a variable which holds the token
            }
        })

        store.dispatch(getParam(gblParamData.data))
    }

    render() {
        const { username, password, hidden } = this.state;

        return (
            <>

                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col col-md-5 d-flex flex-column justify-content-center align-items-center text-white' style={{ background: "#034C99", backgroundImage: 'url("/assets/img/bg-login.png")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', minHeight: '100vh' }}>
                            <div className="illustration mb-5" style={{ marginTop: "13rem" }}>
                                <img src="/assets/img/nayaga-logo/NayagaPP-White.svg" alt="App Logo" style={{ width: "20rem" }}></img>
                            </div>
                            <h3 className='font-weight-bold text-center'>Selamat Datang di System Digital Nayaga Participant Platform</h3>
                            <h5 className='text-center'>Silahkan Masuk menggunakan akun Anda untuk menikmati layanan digital Nayaga Dana Pensiun Participant Platform</h5>
                            <div className="illustration" style={{ paddingTop: "30%" }}>
                                <img src="/assets/img/nayaga-logo/NayagaPP-Tameng.svg" alt="Support Logo" style={{ width: "18rem" }}></img>
                            </div>
                        </div>
                        <div className='col d-flex flex-column justify-content-center align-items-center'>
                            <div className="login-clean">
                                <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
                                    <div className="text-left">
                                        <span className="font-weight-bold" style={{ fontSize: '1.2rem' }}>Selamat Datang !</span>
                                    </div>
                                    <Form.Group className="form-group text-left mb-3" controlId="username">
                                        <span style={{ fontSize: '0.8rem' }}>Masukan <span className="font-weight-bold">User ID</span> Anda yang telah terdaftar</span>
                                    </Form.Group>
                                    <div id="error" style={{ display: 'none' }} class="alert alert-danger" role="alert">
                                        <i class="fas fa-exclamation-circle" style={{color: "#7d3331"}}></i> <span id="errorMessage"></span>
                                    </div>
                                    <Form.Group className="form-group mb-3" controlId="username">
                                        <Form.Label>User ID</Form.Label>
                                        <Form.Control
                                            required
                                            className="form-control form-control-sm"
                                            type="text"
                                            placeholder="User ID"
                                            name="username"
                                            value={username}
                                            onChange={this.handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            User ID Wajib diisi
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="form-group position-relative" controlId="password">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            required
                                            className="form-control form-control-sm"
                                            type={hidden ? "password" : "text"}
                                            placeholder="Kata Sandi"
                                            name="password"
                                            value={password}
                                            onChange={this.handleChange}
                                        />
                                        <i className={`${hidden ? "far fa-eye-slash" : "far fa-eye"} reveal-password`} onClick={this.toggleShow.bind(this)} />
                                        <Form.Control.Feedback type="invalid">
                                            Password Wajib diisi
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-5">
                                        <Form.Check
                                            label="Remember me"
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group" controlId="button">
                                        <Button className="btn btn-blue text-white btn-lg btn-block btn-sm" type="submit" style={{ borderRadius: "15px" }}>Masuk</Button>
                                    </Form.Group>
                                    <Form.Group className="form-group text-center" controlId="a">
                                        <a href="/">Lupa Password</a>
                                    </Form.Group>
                                </Form>
                            </div>
                            <span className='text-center' style={{ fontSize: '13px' }}>Copyright &copy; 2023 - Dana Pensiun Nayaga by Cakratech</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Dashboard